import { render } from "./BetreuungszeitenTable.vue?vue&type=template&id=05f979a5&scoped=true"
import script from "./BetreuungszeitenTable.vue?vue&type=script&lang=js"
export * from "./BetreuungszeitenTable.vue?vue&type=script&lang=js"

import "./BetreuungszeitenTable.vue?vue&type=style&index=0&id=05f979a5&lang=stylus&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f979a5"]])

export default __exports__